import React, {useState, useEffect} from 'react'
import * as List from "../../Utils/FunctionList";
import ReportModal from "./ReportModal/ReportModal";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

const ModalController = (props) => {
    const [isOpen, setIsOpen] = useState(false)
    const [type, setType] = useState('')
    const [metadata, setMetadata] = useState({})

    useEffect(() => {
        if (isOpen !== props.isOpen) {
            setIsOpen(props.isModalOpen)
        }

        if (type !== props.typeOfModal) {
            setType(props.typeOfModal)
        }

        if (metadata !== props.metadata) {
            setMetadata(props.metadata)
        }

    }, [props.isModalOpen, props.typeOfModal, props.metadata])

    if (type === List.SUPPORTED_FUNCTIONS.REPORT_MODAL) {
        return (
            <ReportModal
                isOpen={isOpen}
                type={type}
                metadata={metadata}
                setModalController={props.setModalController}
                auth={props.auth}
            />
        )
    } else {
        return (<div></div>)
    }

}

const mapDispatchToProps = dispatch => {
    return {
        setModalController: (state) => dispatch({
            type: state.type,
            typeOfModal: state.typeOfModal,
            isModalOpen: state.isModalOpen,
            metadata: state.metadata
        })
    }
}

const mapStateToProps = state => {
    return {
        typeOfModal: state.setModalController.typeOfModal,
        isModalOpen: state.setModalController.isModalOpen,
        metadata: state.setModalController.metadata,
        auth: state.firebase.auth
    }

}

const enhance = connect(
    mapStateToProps,
    mapDispatchToProps
)

export default enhance(withRouter(ModalController))